module.exports = __webpack_public_path__ + "static/media/delivery-truck.699f04ef.svg";